import { useCallback } from 'react';
import { toastErrorMessage } from 'utils/helpers';
import { useMutation } from '@apollo/client/react';
import {
  RequestExpressLoanPersonalOfferDocument,
  type ExpressLoanPersonalOfferInput,
} from 'graphql/generated/graphql';

const useRequestExpressLoanPersonalOffer = () => {
  const [requestPersonalOfferMutation] = useMutation(RequestExpressLoanPersonalOfferDocument, {
    onError: toastErrorMessage,
  });

  const handleRequestPersonalOffer = useCallback(
    async (id: string, formData: ExpressLoanPersonalOfferInput) => {
      // onError has handled a failure: with an onError option the mutation resolved under Apollo Client 2, Apollo
      // Client 4 rejects after calling it.
      await requestPersonalOfferMutation({ variables: { id, formData } }).catch(() => undefined);
    },
    [requestPersonalOfferMutation],
  );
  return handleRequestPersonalOffer;
};

export default useRequestExpressLoanPersonalOffer;
